// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { sub as fn } from "../sub.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const sub = convertToFP(fn, 2);

// Fallback for modularized imports:
export default sub;
